import apiClient from './apiClient';

const salaryStructureService = {
  getAll: async (filters = {}) => {
    const response = await apiClient.get('/salary-structures', { params: filters });
    return response.data;
  },

  getCurrent: async (filters = {}) => {
    const response = await apiClient.get('/salary-structures/current', { params: filters });
    return response.data;
  },

  create: async (payload) => {
    const response = await apiClient.post('/salary-structures', payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await apiClient.put(`/salary-structures/${id}`, payload);
    return response.data;
  }
};

export default salaryStructureService;
